"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_1 = __importDefault(require("i18next"));
var i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
var react_i18next_1 = require("react-i18next");
var transalations_1 = __importDefault(require("./translations/transalations"));
var language = localStorage.getItem("i18nextLng");
i18next_1.default
    .use(i18next_browser_languagedetector_1.default)
    .use(react_i18next_1.initReactI18next)
    .init({
    resources: __assign({}, transalations_1.default),
    fallbackLng: language ? language : "en-US",
    debug: true,
    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: ".",
    returnObjects: true,
    interpolation: {
        escapeValue: false,
    },
});
exports.default = i18next_1.default;
